/* eslint-disable no-param-reassign */

/* eslint-disable complexity */
/* eslint-disable max-statements */
/* eslint-disable max-depth */

// import { Vector } from '.';
import { Vertex2 } from '@rta/rta-blueprint-library';

import { fixVectorDirection } from '@r-core/helpers';
import { Layer, type Vector } from '@r-core/types';

const reverseVector = (vector: Vector<Vertex2>): Vector<Vertex2> => {
	if (vector.angle === -90) {
		// Use plain objects to avoid Vertex2 getter issues
		return {
			...vector,
			from: { x: vector.to.x, y: vector.to.y } as Vertex2,
			to: { x: vector.from.x, y: vector.from.y } as Vertex2
		};
	}
	return vector;
};

export const addVector = (vectors: Array<Vector<Vertex2>>, inVector: Vector<Vertex2>): Array<Vector<Vertex2>> => {
	let retVectors: Array<Vector<Vertex2>> = [];
	let isUpdated = false;

	const newVector = fixVectorDirection(inVector);

	// splice vector overlaps
	retVectors = vectors.reduce((retVector, vector) => {
		// only test for overlaps in the same layer
		if (vector.layer === newVector.layer) {
			// console.log('start segment', vector, newVector);
			// deal with overlaps along the x axis.
			if (newVector.angle === 90 && (vector.angle === 90 || vector.angle === -90) && (newVector.from.y === vector.from.y || newVector.to.y === vector.to.y)) {
				let fromOverlap = false;
				let toOverlap = false;

				if (vector.angle === -90) {
					vector = reverseVector(vector);
				}

				fromOverlap = newVector.from.x >= vector.from.x && newVector.from.x <= vector.to.x;
				toOverlap = newVector.to.x >= vector.from.x && newVector.to.x <= vector.to.x;
				// console.log(`testing segment on x: ${fromOverlap}|${toOverlap}`, vector, newVector);

				// remove overlap, split vector into 2
				if (fromOverlap || toOverlap) {
					const retValue = [...retVector];
					isUpdated = true;
					// console.log(`exclude segment on x: ${fromOverlap}|${toOverlap}`, newVector);

					if (fromOverlap && toOverlap) {
						retValue.push({
							...vector,
							to: { x: newVector.from.x, y: newVector.from.y } as Vertex2
						});
						retValue.push({
							...vector,
							from: { x: newVector.to.x, y: newVector.to.y } as Vertex2
						});
					} else {
						if (fromOverlap) {
							retValue.push({
								...vector,
								to: { x: newVector.from.x, y: newVector.from.y } as Vertex2
							});
						}

						if (toOverlap) {
							retValue.push({
								...vector,
								from: { x: newVector.to.x, y: newVector.to.y } as Vertex2
							});
						}
					}

					return retValue;
				}
			}

			// deal with overlaps along the y axis.
			if (newVector.angle === 0 && newVector.angle === vector.angle && (newVector.from.x === vector.from.x || newVector.to.x === vector.to.x)) {
				const vectorLength = vector.to.y - vector.from.y;
				const newVectorLength = newVector.to.y - newVector.from.y;
				let fromOverlap = false;
				let toOverlap = false;

				fromOverlap = newVector.from.y >= vector.from.y && newVector.from.y <= vector.to.y;
				toOverlap = newVector.to.y >= vector.from.y && newVector.to.y <= vector.to.y;
				// console.log(`testing segment on y: ${fromOverlap}|${toOverlap}`, vector, newVector);

				// remove overlap, split vector into 2
				if (fromOverlap || toOverlap) {
					const retValue = [...retVector];
					isUpdated = true;
					// console.log(`exclude segment on y: ${fromOverlap}|${toOverlap}`, vectorLength, newVectorLength, newVector);

					if (fromOverlap && toOverlap) {
						retValue.push({
							...vector,
							to: { x: newVector.from.x, y: newVector.from.y } as Vertex2
						});
						retValue.push({
							...vector,
							from: { x: newVector.to.x, y: newVector.to.y } as Vertex2
						});
					} else {
						if (fromOverlap) {
							retValue.push(newVectorLength > vectorLength
								? { ...{ ...newVector, angle: 0 }, from: { x: vector.to.x, y: vector.to.y } as Vertex2 }
								: { ...vector, to: { x: newVector.from.x, y: newVector.from.y } as Vertex2 });
						}

						if (toOverlap) {
							// console.log('updated vector', { ...{ ...newVector, angle: 0 }, from: vector.to });
							retValue.push(newVectorLength > vectorLength
								? { ...{ ...newVector, angle: 0 }, to: { x: vector.from.x, y: vector.from.y } as Vertex2 }
								: { ...vector, from: { x: newVector.to.x, y: newVector.to.y } as Vertex2 });
						}
					}

					return retValue;
				}
			}
		}

		retVector.push(vector);
		return retVector;
	}, retVectors);

	if (!isUpdated) retVectors.push({ ...newVector });
	// console.log('revVectors', isUpdated, vectors.length, retVectors.length, retVectors);

	return retVectors;
};

export type AddVectorsOptions = {
	vectors: Array<Vector<Vertex2>>;
	newVectors: Array<Vector<Vertex2>>;
	setLayer?: Layer;
}

export const addVectors = (sku: string, { vectors, newVectors, setLayer }: AddVectorsOptions): Array<Vector<Vertex2>> => {
	// console.log(`addVectors:${sku}`, newVectors);
	const retVectors = newVectors.reduce((uVector, newVector) => {
		return addVector(uVector, { ...newVector, layer: typeof setLayer === 'undefined' ? newVector.layer : setLayer });
	}, vectors);

	return retVectors;
};
